import { Button, Loader, Stack, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { notifications } from "@mantine/notifications";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";
import { useParams } from "react-router-dom";
import { deselectAll } from "../../utils";
import { transformFilterToServer } from "../../../../../functions/utilFunctions";
import { executeCron, findCron, getCrons } from "../../../../../api/ConfigsApi";
import { useProfileStore } from "../../../../../stores/UserStore";
import { IconCloudUpload } from "@tabler/icons-react";

const defaults = ["opener", "clicker", "answerer", "to_call", "out_of_office"];

const LeadsBulkMakeSelection = ({ type, handleClose, onFinish, tableFilter, tableSelection }) => {
  const lang = useLanguage((s) => s.language);
  const query = useLeadsStore((s) => s.query);
  const { userId } = useParams();

  const globalFilter = useLeadsStore((s) => s.filter);
  const globalSelectedIds = useLeadsContainerStore((s) => s.selectedIds);
  const unselectedIds = useLeadsContainerStore((s) => s.unselectedIds);
  const selectedColumns = useLeadsContainerStore((s) => s.selectedColumns);

  const [items, setItems] = useState([]);

  const selectedIds = tableSelection || globalSelectedIds;
  const filter = tableFilter ? transformFilterToServer(tableFilter) : globalFilter;
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(null);

  const main = (cron_id) => {
    let mainFilterValues = [];
    let excluded = [];
    if (selectedColumns.length > 0) {
      selectedColumns.forEach((col) => {
        if (defaults.includes(col)) {
          let v = [
            {
              field_name: "status",
              type: "equals",
              value: col,
            },
            {
              field_name: "custom_status",
              type: "equals",
              value: "null",
            },
          ];

          if (query) {
            v.push({
              field_name: "any_datafield",
              type: "contains",
              value: query,
            });
          }

          if (filter) {
            v.push(filter);
          }

          mainFilterValues.push({
            mode: "and",
            values: v,
          });
        } else {
          let v = [
            {
              field_name: "custom_status",
              type: "equals",
              value: col.toString(),
            },
          ];

          if (filter) {
            v.push(filter);
          }

          mainFilterValues.push({
            mode: "and",
            values: v,
          });
        }
        if (unselectedIds[col]) {
          excluded.push(...unselectedIds[col]);
        }
      });
    }

    let parsedFilter = {
      mode: "or",
      values: mainFilterValues,
    };

    let justFilter = {
      mode: "and",
      values: [],
    };
    if (type === "filter" && filter) {
      justFilter.values.push(filter);
    }
    if (type === "filter" && query) {
      justFilter.values.push({
        field_name: "any_datafield",
        type: "contains",
        value: query,
      });
    }

    setSyncing(cron_id);

    findCron(cron_id)
      .then((r) => {
        let cronData = r.data.cron_profile.arguments;
        executeCron({
          id: cron_id,
          args: {
            type: "prm_synchronise_with_make",
            datafield_ids: cronData.datafield_ids,
            contacts_selection: {
              contact_ids:
                type === "selection_inverse" || type === "all"
                  ? []
                  : Object.values(selectedIds).flatMap((x) => x),
              excluded_contact_ids:
                type === "selection_inverse"
                  ? Object.values(unselectedIds).flatMap((x) => x)
                  : [],
              filter: type === "filter" ? justFilter : parsedFilter,
            },
            prm_user_id:
              parseInt(userId) || useProfileStore.getState().profile?.id,
            resend_synchronized_contacts: true,
            hook_url: cronData?.hook_url,
          },
        })
          .then((res) => {
            onFinish?.(type);
            notifications.show({
              message: lang.sync_zapier.send_success,
              color: "tertiary.8",
            });
            handleClose();

            if (type === "selection") {
              deselectAll();
            }
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => setSyncing(null));
  };

  useEffect(() => {
    getCrons()
      .then((response) => {
        setItems(
          response.data.crons_list
            .sort((a, b) => b.id - a.id)
            .filter((x) => x.type === "prm_synchronise_with_make")
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Stack miw={300} mih={50} align="center" justify="center">
      {
        loading ? <Loader /> :
          items.map((item, index) => {
            return (
              <Button
                variant="light"
                key={item?.id}
                onClick={() => main(item.id)}
                loading={syncing === item.id}
                disabled={syncing}
                h={48}
                w={"100%"}
                leftSection={<IconCloudUpload size={18} />}
              >
                <Stack gap={4} maw={250} align="start">
                  <Text fw={600} truncate>{item.name}</Text>
                  {/* <Text size="sm" truncate maw={250}>{item.url}</Text> */}
                </Stack>
              </Button>
            );
          })}
    </Stack>
  );
};

export default LeadsBulkMakeSelection;
